var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"value":_vm.drawer,"app":"","clipped":""},on:{"input":function (val){ return _vm.$emit('transitionend', val); }}},[[_c('ProjectList')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }